// extracted by mini-css-extract-plugin
export var md = "768px";
export var questionPageQuestionsContainer = "QuestionPage_questionPageQuestionsContainer__FMGtr";
export var shared = "\"../../shared.module.css\"";